import { Typography } from 'antd';

const AddressDisplay = ({ address }) => {
  if (!address) {
    return <div></div>;
  }

  const street2 = address.street2 ? ` ${address.street2}` : '';
  const streetAddress = `${address.street1}${street2}`;
  const cityStateZip = `${address.city}, ${address.state} ${address.postalCode}`;

  return (
    <div style={{ marginLeft: 'var(--spacing)' }}>
      <Typography.Text italic>
        {streetAddress}
        <br></br>
        {cityStateZip}
      </Typography.Text>
    </div>
  );
};

export default AddressDisplay;
